'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _redux = require('redux');

var _autocomplete = require('./autocomplete');

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _createReviewModal = require('./create-review-modal');

var _createReviewModal2 = _interopRequireDefault(_createReviewModal);

var _errors = require('./errors');

var _errors2 = _interopRequireDefault(_errors);

var _listings = require('./listings');

var _listings2 = _interopRequireDefault(_listings);

var _searchTerms = require('./search-terms');

var _searchTerms2 = _interopRequireDefault(_searchTerms);

var _topNav = require('./top-nav');

var _topNav2 = _interopRequireDefault(_topNav);

var _app = require('./app');

var _app2 = _interopRequireDefault(_app);

var _mobileSearchMenu = require('./mobile-search-menu');

var _mobileSearchMenu2 = _interopRequireDefault(_mobileSearchMenu);

var _cookieModal = require('./cookie-modal');

var _cookieModal2 = _interopRequireDefault(_cookieModal);

var _reportModal = require('./report-modal');

var _reportModal2 = _interopRequireDefault(_reportModal);

var _reviewModal = require('./review-modal');

var _reviewModal2 = _interopRequireDefault(_reviewModal);

var _signUpModal = require('./sign-up-modal');

var _signUpModal2 = _interopRequireDefault(_signUpModal);

var _accountProfileData = require('./account-profile-data');

var _accountProfileData2 = _interopRequireDefault(_accountProfileData);

var _expiredSessionModal = require('./expired-session-modal');

var _expiredSessionModal2 = _interopRequireDefault(_expiredSessionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
	autocomplete: _autocomplete2.default,
	createReviewModal: _createReviewModal2.default,
	errors: _errors2.default,
	listings: _listings2.default,
	searchTerms: _searchTerms2.default,
	topNav: _topNav2.default,
	mobileSearchMenu: _mobileSearchMenu2.default,
	reviewModal: _reviewModal2.default,
	signUpModal: _signUpModal2.default,
	cookieModal: _cookieModal2.default,
	reportModal: _reportModal2.default,
	expiredSessionModal: _expiredSessionModal2.default,
	accountProfileData: _accountProfileData2.default,
	app: _app2.default
});